.zento-marketing-box-wrapper {
  margin-top: 240px;
  position: relative;

  .zento-marketing-box-inner {
    z-index: 5;
    position: relative;
  }

  &:after {
    content: '';
    background-color: #0076C0;
    clip-path: polygon(120px 0, 100% 0, 100% 120px, 100% 120px, 100% 100%, 0 100%, 0% 120px, 0 120px);
    -webkit-clip-path: polygon(120px 0, 100% 0, 100% 120px, 100% 120px, 100% 100%, 0 100%, 0% 120px, 0 120px);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: absolute;
  }

  .zento-marketing-box {
    padding: 120px 20px;
    color: #fff;
    text-align: center;

    .subtitle {
      color: #fff;
      margin-bottom: 24px;
      font-weight: 600;
      font-style: normal;
      font-size: 42px;
      line-height: 1.3333333333;
    }

    .item-link {
      display: inline-block;
      border: 2px solid #FFFFFF;
      padding: 17px 32px;
      text-decoration: none;
      background-color: transparent;
      font-weight: 600;
      color: #fff;
      cursor: pointer;

      &:hover {
        background-color: rgba(255,255,255,0.2);
      }
    }
  }
}

@media (max-width: 1450px) {
  .zento-marketing-box-wrapper {
    margin-top: 160px;
  }
}

@media (max-width: 1199px) {
  .zento-marketing-box-wrapper {
    margin-top: 120px;
  }
}

@media (max-width: 995px) {
  .zento-marketing-box-wrapper {
    margin-top: 96px;

    &:after {
      clip-path: polygon(60px 0, 100% 0, 100% 60px, 100% 60px, 100% 100%, 0 100%, 0% 60px, 0 60px);
      -webkit-clip-path: polygon(60px 0, 100% 0, 100% 60px, 100% 60px, 100% 100%, 0 100%, 0% 60px, 0 60px);
    }

    .zento-marketing-box {
      padding: 80px 20px;

      .subtitle {
        font-size: 31px;
      }
    }
  }
}

@media (max-width: 639px) {
  .zento-marketing-box-wrapper {
    .zento-marketing-box {
      padding: 48px 20px;

      .subtitle {
        font-size: 16px;
        min-height: 20px;
      }
    }
  }
}
